import { BASE_URL } from "@/utils/Constants";
import { useAuthStore } from "@/utils/stores/useAuthStore";
import { useState } from "react";

export const useUpdateRecordBySortingId = () => {
    const { auth } = useAuthStore();
    const idToken = auth.idToken;

    const [data, setData] = useState<any>(null);
    const [error, setError] = useState<string | null>(null);
    const [loading, setLoading] = useState<boolean>(false);

    const patchRecord = async (sorting_id: string, fields: Record<string, any>) => {
        if (!sorting_id || !idToken) {
            setError("Missing sorting_id or auth token");
            return;
        }

        setLoading(true);
        setError(null);

        try {
            const response = await fetch(`${BASE_URL}/api/airtable/update-by-sorting-id/${sorting_id}`, {
                method: 'PATCH',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${idToken}`,
                },
                body: JSON.stringify({ fields }),
            });

            const result = await response.json();

            if (!response.ok) {
                setError(result.detail || "Errore durante l'aggiornamento del record");
                setData(null);
            } else {
                setData(result.record);
                setError(null);
            }
        } catch (err) {
            console.error("Error patching record:", err);
            setError("Errore imprevisto durante l'aggiornamento del record");
            setData(null);
        } finally {
            setLoading(false);
        }
    };

    return { patchRecord, data, error, loading };
}